<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center"><span style="font-size: 3em; line-height: 1.2em;"><strong>THE<br/>BLONDE</strong></span></p>
<p class="center"><span style="font-size: 1.2em; line-height: 1.2em;"><strong>Duane<br/>Swierczynski</strong></span><br/><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?de68bab2